// Main javascript entry point
// Should handle bootstrapping/starting application

"use strict";

import $ from "jquery";
import "jquery-match-height";
import Emitter from "tiny-emitter";
import tablesawJquery from "tablesaw/dist/tablesaw.jquery";

import { checkHover, setVh, viewportAnimate } from "./utils";
import { tripHandler } from "./tripHandler";
import { profileCookieHandler } from "./profileCookieHandler";

import CookieMessage from "../_modules/molecules/cookie-message/cookie-message";
import SiteHeader from "../_modules/organisms/site-header/site-header";
import Partners from "../_modules/organisms/partners/partners";
import Gallery from "../_modules/organisms/gallery/gallery";
import StoryListing from "../_modules/organisms/story-listing/story-listing";
import ProgrammeListing from "../_modules/organisms/programme-listing/programme-listing";
import NewsListing from "../_modules/organisms/news-listing/news-listing";
import EventsListing from "../_modules/organisms/events-listing/events-listing";
import DetailAside from "../_modules/organisms/detail-aside/detail-aside";
import AnchorNav from "../_modules/organisms/anchor-nav/anchor-nav";
import RegulationListing from "../_modules/organisms/regulation-listing/regulation-listing";
import VideoPlayer from "../_modules/molecules/video-player/video-player";
import Newsroom from "../_modules/organisms/newsroom/newsroom";
import SearchResults from "../_modules/organisms/search-results/search-results";
import DigitalsolListing from "../_modules/organisms/digitalsol-listing/digitalsol-listing";
import AccordionList from "../_modules/organisms/accordion-list/accordion-list";
import StandardContentCarousel from "../_modules/organisms/standard-content-carousel/standard-content-carousel";
import StoriesCarousel from "../_modules/organisms/stories-carousel/stories-carousel";
import PeopleCarousel from "../_modules/organisms/people-carousel/people-carousel";
import DigitalBlocks from "../_modules/organisms/digital-blocks/digital-blocks";
import ArticleGalleryCarousel from "../_modules/organisms/article-gallery-carousel/article-gallery-carousel";
import HomeTabs from "../_modules/organisms/home-tabs/home-tabs";
import HomeBanner from "../_modules/organisms/home-banner/home-banner";
import ProfileLanding from "../_modules/organisms/profile-landing/profile-landing";
import ArticleListingWithQuestionnaire from "../_modules/organisms/article-listing-with-questionnaire/article-listing-with-questionnaire";
import PageBanner from "../_modules/organisms/page-banner/page-banner";
import Rte from "../_modules/molecules/rte/rte";
import InnovativeTechListing from "../_modules/organisms/innovative-tech-listing/innovative-tech-listing";
import CallToActions from "../_modules/organisms/call-to-actions/call-to-actions";
import TwoColCarousel from "../_modules/organisms/two-col-carousel/two-col-carousel";
import ThreeColImgcard from "../_modules/organisms/three-col-imgcard/three-col-imgcard";
import RelatedPosts from "../_modules/organisms/related-posts/related-posts";
import AccordionSliders from "../_modules/organisms/accordion-sliders/accordion-sliders";
import CollapsibleContent from "../_modules/molecules/collapsible-content/collapsible-content";
import TwoColImgquote from "../_modules/organisms/two-col-imgquote/two-col-imgquote";
import ModalCarousel from "../_modules/organisms/modal-carousel/modal-carousel";
import FeaturedStories from "../_modules/organisms/featured-stories/featured-stories";
import SuccessStories from "../_modules/organisms/success-stories/success-stories";
import ThoughtLeadership from "../_modules/organisms/thought-leadership/thought-leadership";
import BrowseInterest from "../_modules/organisms/browse-interest/browse-interest";
import EventCardCarousel from "../_modules/organisms/event-card-carousel/event-card-carousel";
import CareerImgCarousel from "../_modules/organisms/career-img-carousel/career-img-carousel";
import VideoLoader from "../_modules/organisms/video-loader/video-loader";
import TextCarousel from "../_modules/organisms/text-carousel/text-carousel";
import EventSpeakers from "../_modules/organisms/event-speakers/event-speakers";
import AnchorNavEvents from "../_modules/organisms/anchor-nav-events/anchor-nav-events";
import EventDetailsSection from "../_modules/organisms/event-details-section/event-details-section";
import EventDetailsBanner from "../_modules/organisms/event-details-banner/event-details-banner";
import EventsLandingBanner from "../_modules/organisms/events-landing-banner/events-landing-banner";
import FeaturedEventsCarousel from "../_modules/organisms/featured-events-carousel/featured-events-carousel";
import EventsSearch from "../_modules/organisms/events-search/events-search";
import BackToTop from "../_modules/atoms/back-to-top/back-to-top";
import FullBleedAccordions from "../_modules/organisms/full-bleed-accordions/full-bleed-accordions";
import Footnote from "../_modules/molecules/footnote/footnote";
import ArticleLink from "../_modules/molecules/article-link/article-link"
import Modal from "../_modules/modal/modal";
import AnnouncementBanner from "../_modules/molecules/announcement-banner/announcement-banner";
// import LoadingScreen from "../_modules/organisms/loading-screen/loading-screen";
import TextCardCarousel from "../_modules/organisms/text-card-carousel/text-card-carousel";
import BannerWithTimer from "../_modules/organisms/banner-with-timer/banner-with-timer";
import ContentTabs from "../_modules/organisms/content-tabs/content-tabs";
import PopupOverlay from "../_modules/organisms/popup-overlay/popup-overlay";
import ProgressBar from "../_modules/molecules/progress-bar/progress-bar";
import VideoCarousel from "../_modules/organisms/video-carousel/video-carousel";
import HighlightsCarousel from "../_modules/organisms/highlights-carousel/highlights-carousel";
import ExploreFilmsCarousel from "../_modules/organisms/explore-films-carousel/explore-films-carousel";
import FilmLandingBanner from "../_modules/organisms/film-landing-banner/film-landing-banner";
import FilmTvListing from "../_modules/organisms/film-tv-listing/film-tv-listing";
import FilmGalleryBanner from "../_modules/organisms/film-gallery-banner/film-gallery-banner";
import RelatedFilmNews from "../_modules/organisms/related-film-news/related-film-news";
import RecommendedFilms from "../_modules/organisms/recommended-films/recommended-films";
import ShowMoreList from "../_modules/organisms/show-more-list/show-more-list";
import TwoColAccordion from "../_modules/molecules/two-col-accordion/two-col-accordion";
import ImageInfo from "../_modules/organisms/image-info/image-info";

$(() => {
  checkHover();
  setVh();

  // if($('.loading-screen').length) {
  //   new LoadingScreen();
  // }

  const config = {
    breakpoints: {
      tablet: 768,
      desktop: 1024,
      lgDesktop: 1280,
    },
  };

  window.emitter = new Emitter();

  profileCookieHandler();

  $(".match-height, .has-match-height").matchHeight();

  viewportAnimate();

  if (!localStorage.getItem("visitedHome")) {
    // set visited homepage item to check for guided tour condition to show
    if ($("body").hasClass("is-homepage")) {
      // is any homepage
      localStorage.setItem("visitedHome", true);
    }
  }

  new Modal();

  if ($(".announcement-banners").length) {
    $(".announcement-banners").map((i, ele) => {
      new AnnouncementBanner($(ele));
    });
  }

  if ($(".back-to-top").length) {
    $(".back-to-top").map((i, ele) => {
      new BackToTop($(ele));
    });
  }

  if ($(".site-header .site-header__main").length) {
    new SiteHeader($(".site-header"), true, config);
  }

  if ($(".home-tabs").length) {
    $(".home-tabs").map((i, ele) => {
      new HomeTabs($(ele));
    });
  }

  if ($(".page-banner").length) {
    $(".page-banner").map((i, ele) => {
      new PageBanner($(ele));
    });
  }

  if ($(".accordion-list").length) {
    $(".accordion-list").map((i, ele) => {
      new AccordionList($(ele));
    });
  }

  if ($(".profile-selector").length) {
    $(".profile-selector").map((i, ele) => {
      new ProfileLanding($(ele));
    });
  }

  if ($(".home-banner").length) {
    $(".home-banner").map((i, ele) => {
      new HomeBanner($(ele), true, config);
    });
  }

  if ($(".articles-with-questionnaire").length) {
    $(".articles-with-questionnaire").map((i, ele) => {
      new ArticleListingWithQuestionnaire($(ele));
    });
  }

  if ($(".digital-blocks").length) {
    $(".digital-blocks").map((i, ele) => {
      new DigitalBlocks($(ele), true, config);
    });
  }

  if ($(".article-gallery-carousel").length) {
    $(".article-gallery-carousel").map((i, ele) => {
      new ArticleGalleryCarousel($(ele), true, config);
    });
  }

  if ($(".stories-carousel").length) {
    $(".stories-carousel").map((i, ele) => {
      new StoriesCarousel($(ele), true, config);
    });
  }

  if ($(".people-carousel").length) {
    $(".people-carousel").map((i, ele) => {
      new PeopleCarousel($(ele), true, config);
    });
  }

  if ($(".call-to-actions.no-desktop").length) {
    $(".call-to-actions.no-desktop").map((i, ele) => {
      new CallToActions($(ele));
    });
  }

  if ($(".detail-aside").length) {
    new DetailAside();
  }

  if ($(".detail-wrapper .anchor-nav").length) {
    new AnchorNav();
    const hash = window.location.hash;

    if ($(hash).length) {
      $("html, body").animate({
        scrollTop:
          $(hash).offset().top - $(".site-header").outerHeight() - 30,
      });
    }
  }

  if ($(".event-detail-wrapper .anchor-nav").length) {
    new AnchorNavEvents();
    const hash = window.location.hash;

    if ($(hash).length) {
      $("html, body").animate({
        scrollTop:
          $(hash).offset().top - $(".site-header").outerHeight() - 30,
      });
    }
  }

  if ($(".cookie-message").length) {
    new CookieMessage();
  }

  if ($(".standard-content__carousel").length) {
    $(".standard-content__carousel").map((i, ele) => {
      new StandardContentCarousel($(ele), true, config);
    });
  }

  if ($(".partners").length) {
    $(".partners").map((i, ele) => {
      new Partners($(ele), true, config);
    });
  }

  if ($(".gallery").length) {
    $(".gallery").map((i, ele) => {
      new Gallery($(ele), true, config);
    });
  }

  if ($(".story-listing").length) {
    new StoryListing(config);
  }

  if ($(".programme-listing").length) {
    new ProgrammeListing();
  }

  if ($(".news-listing").length) {
    new NewsListing();
  }

  if ($(".digitalsol-listing").length) {
    new DigitalsolListing(config);
  }

  if ($(".innovative-tech-listing").length) {
    new InnovativeTechListing();
  }

  if ($(".events-listing").length) {
    new EventsListing();
  }

  if ($(".newsroom").length) {
    new Newsroom();
  }

  if ($(".regulation-listing").length) {
    new RegulationListing();
  }

  if ($(".search-results").length) {
    $(".search-results").map((i, ele) => {
      new SearchResults($(ele), true, config);
    });
  }

  if ($(".video-gallery").length) {
    $(".video-gallery").map((i, ele) => {
      new VideoCarousel($(ele), true, config);
    });
  }

  if ($(".video-player").length) {
    const iframeAPI = "https://www.youtube.com/iframe_api";

    if (!$('script[src="' + iframeAPI + '"]').length) {
      const firstScriptTag = document.getElementsByTagName("script")[0];
      const tag = document.createElement("script");
      tag.src = iframeAPI;
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    const players = [];
    const videoPlayers = [];

    $(".video-player:not([data-modal-video])").map((i, video) => {
      const playerData = {
        id: $(video).find(".video-player__holder").attr("id"),
        videoId: $(video).data("videoId"),
        YTPlayer: null,
      };
      players.push(playerData);

      const videoPlayerInstance = new VideoPlayer($(video), true, playerData);
      videoPlayers.push(videoPlayerInstance);
    });

    window.onYouTubeIframeAPIReady = () => {
      players.map((player, i) => {
        player.YTPlayer = new YT.Player(player.id, {
          videoId: player.videoId,
          events: {
            onReady: (e) => {
              videoPlayers[i].onReady($(".video-player").eq(i));
            },
          },
        });
      });
    };
  }

  if ($(".rte table").length) {
    $(".rte table").map((i, ele) => {
      new Rte($(ele));
    });

    tablesawJquery.init();
  }

  // for anchors scroll to correction due to sticky header
  $(`a[href^="#"]`).map((i,ele) => {
    if(!$(ele).parents('.anchor-nav').length && !$(ele).hasClass('accordion-title') && !$(ele).parents('.home-tabs').length && !$(ele).parents('.content-tabs').length && !$(ele).parents('.site-header__profile').length) {
      $(ele).on('click', (e) => {
        e.preventDefault();
  
        const target = $(ele).attr('href');
        const anchorNavHeight = $('.anchor-nav').outerHeight();
  
        $("html, body").animate({
          scrollTop:
            $(target).offset().top - $(".site-header").outerHeight() - anchorNavHeight,
        });
      });
    }
  });

  //CTA Widgets
  if ($(".two-col-carousel").length) {
    $(".two-col-carousel").map((i, ele) => {
      new TwoColCarousel($(ele), true, config);
    });
  }

  if ($(".three-col-imgcard").length) {
    $(".three-col-imgcard").map((i, ele) => {
      new ThreeColImgcard($(ele), true, config);
    });
  }

  if ($(".related-posts").length) {
    $(".related-posts").map((i, ele) => {
      new RelatedPosts($(ele), true, config);
    });
  }

  if ($(".collapsible-content").length) {
    $(".collapsible-content").map((i, ele) => {
      new CollapsibleContent($(ele));
    });
  }

  if ($(".accordion-sliders").length) {
    $(".accordion-sliders").map((i, ele) => {
      new AccordionSliders($(ele));
    });
  }

  if ($(".two-col-imgquote").length) {
    $(".two-col-imgquote").map((i, ele) => {
      new TwoColImgquote($(ele));
    });
  }

  if ($(".featured-stories").length) {
    $(".featured-stories").map((i, ele) => {
      new FeaturedStories($(ele));
    });
  }

  if ($(".success-stories").length) {
    $(".success-stories").map((i, ele) => {
      new SuccessStories($(ele));
    });
  }

  if ($(".thought-leadership").length) {
    $(".thought-leadership").map((i, ele) => {
      new ThoughtLeadership($(ele));
    });
  }

  if ($(".browse-interest").length) {
    $(".browse-interest").map((i, ele) => {
      new BrowseInterest($(ele));
    });
  }

  if ($(".event-details-banner").length) {
    $(".event-details-banner").map((i, ele) => {
      new EventDetailsBanner($(ele));
    });
  }

  if ($(".event-details-section").length) {
    $(".event-details-section").map((i, ele) => {
      new EventDetailsSection($(ele));
    });
  }

  if ($(".event-card-carousel").length) {
    $(".event-card-carousel").map((i, ele) => {
      new EventCardCarousel($(ele), true, config);
    });
  }

  if ($(".career-img-carousel").length) {
    $(".career-img-carousel").map((i, ele) => {
      new CareerImgCarousel($(ele), true, config);
    });
  }

  if ($(".video-loader").length) {
    $(".video-loader").map((i, ele) => {
      new VideoLoader($(ele), true, config);
    });
  }

  if ($(".text-carousel").length) {
    $(".text-carousel").map((i, ele) => {
      new TextCarousel($(ele), true, config);
    });
  }

  if ($(".modal-carousel").length) {
    $(".modal-carousel").map((i, ele) => {
      new ModalCarousel($(ele), true, config);
    });
  }

  if ($(".event-speakers").length) {
    $(".event-speakers").map((i, ele) => {
      new EventSpeakers($(ele), true, config);
    });
  }

  if ($(".events-landing-banner").length) {
    $(".events-landing-banner").map((i, ele) => {
      new EventsLandingBanner($(ele), true, config);
    });
  }

  if ($(".featured-events-carousel").length) {
    $(".featured-events-carousel").map((i, ele) => {
      new FeaturedEventsCarousel($(ele), true, config);
    });
  }

  if ($(".events-search").length) {
    $(".events-search").map((i, ele) => {
      new EventsSearch($(ele));
    });
  }

  if ($(".full-bleed-accordions").length) {
    $(".full-bleed-accordions").map((i, ele) => {
      new FullBleedAccordions($(ele));
    });
  }

  if ($(".footnote").length) {
    $(".footnote").map((i, ele) => {
      new Footnote($(ele));
    });
  }

  if ($(".article-link").length) {
    $(".article-link").map((i, ele) => {
      new ArticleLink($(ele));
    });
  }

  if ($(".hero-banner__starttime").length) {
    $(".hero-banner__starttime").map((i, ele) => {
      new BannerWithTimer($(ele));
    });
  }

  if ($(".text-card-carousel").length) {
    $(".text-card-carousel").map((i, ele) => {
      new TextCardCarousel($(ele), true, config);
    });
  }

  if ($(".content-tabs").length) {
    $(".content-tabs").map((i, ele) => {
      new ContentTabs($(ele));
    });
  }

  if ($(".popup-overlay").length) {
    $(".popup-overlay").map((i, ele) => {
      new PopupOverlay($(ele));
    });
  }

  if ($(".scroll-progress-bar").length) {
    $(".scroll-progress-bar").map((i, ele) => {
      new ProgressBar($(ele));
    });
  }

  if ($(".highlights-carousel").length) {
    $(".highlights-carousel").map((i, ele) => {
      new HighlightsCarousel($(ele));
    });
  }

  if ($(".explore-films-carousel").length) {
    $(".explore-films-carousel").map((i, ele) => {
      new ExploreFilmsCarousel($(ele), true, config);
    });
  }
  
  if ($(".film-landing-banner").length) {
    $(".film-landing-banner").map((i, ele) => {
      new FilmLandingBanner($(ele), true, config);
    });
  }

  if ($(".film-tv-listing").length) {
    $(".film-tv-listing").map((i, ele) => {
      new FilmTvListing($(ele), true, config);
    });
  }  

  if ($(".film-gallery-banner").length) {
    $(".film-gallery-banner").map((i, ele) => {
      new FilmGalleryBanner($(ele), true, config);
    });
  }
  
  if ($(".related-film-news").length) {
    $(".related-film-news").map((i, ele) => {
      new RelatedFilmNews($(ele), true);
    });
  }

  if ($(".recommended-films").length) {
    $(".recommended-films").map((i, ele) => {
      new RecommendedFilms($(ele), true, config);
    });
  }

  if ($(".show-more-list").length) {
    $(".show-more-list").map((i, ele) => {
      new ShowMoreList($(ele));
    });
  }

  if ($(".two-col-accordion").length) {
    $(".two-col-accordion").map((i, ele) => {
      new TwoColAccordion($(ele));
    });
  }

  if ($(".image-info").length) {
    $(".image-info").map((i, ele) => {
      new ImageInfo($(ele), true, config);
    });
  }

  $(window).on('load', (e) => {
    // $('.loading-screen').fadeOut(250, () => {
    //   $('.loading-screen').remove();
    // });
    
    // Only for Singapore Media Festival url
    let href = window.location.href;

    if(href.indexOf('/activities/activities-catalogue/singapore-media-festival-2023') > -1){
     // Handle CDN Cache issue
     let randomNumber =  Math.floor(Math.random() * 9000) + 1000;
     $(".main-content").append(
      `<script type="text/javascript" src="https://login.dotomi.com/profile/visit/js/1_0?dtm_cid=82637&dtm_cmagic=ba045a&dtm_fid=6006&cachebuster=${randomNumber}"></script>`
     );
    }
    
  });

  /**
   * Trip js handler
   */
  tripHandler();
});
